/*
Sohel 12/23/2022 3075154998 Preprocessor new Ux Changes
Sohel 12/30/2022 3075154998 Add processor Group API integration
Sohel 01/03/2023 2701323910 payload Changes
Sohel 01/03/2023 2701323910 fixed prepopulate issue
Akhila 01/05/2023 2701323910 PrePopulated static preprocessor data In Ui
dilip 01/10/2023 2701323910 Added unsaved popup.
Sohel 01/10/2023 2698964415 changed draft condition
Sohel 01/11/2023 2698959212 change stepper position.
Ashraf 01/13/2023 2698959212 disabled finish button when code is not selected
Ashraf 01/13/2023 2698959212 fixed toast messages and loaders
sai krishna 01/16/2023 2698959212 add code and description ,type
Sohel 01/16/2023 2698959212 added Save button
Sohel 01/18/2023 2698964415 added unSaved Popup in go back button
Sohel 01/20/2023 2698964415 Added Last Step in Stepper
Sohel 01/22/2023 2698964415 pass Record Group Props
kavyareddy 01/27/2023 2698964415 Fixed code,description and type display issue
Sohel 01/31/2023 2698964415 fixed group Name reset issue
Dilip 02/01/2023 2698964415 code and description label changes
Sohel 01/02/2023 2698964415 unSaved popup changes
Sohel 02/08/2023 2701335619 Implement Usage Functionality
Raghu 02/23/2023 2701335619 added new class for buttons
suresh peddavoora 02/24/2023 2701335619 New UI changes
Akhila 03/14/2023 2698964415 bug fixed unsaved chnages popup issue
Akhila 03/29/2023 2701335619 unsaved changes popup fixed
Prakash 12-04-23 2698964415 fixed go back color issue in export-template-record.
Prakash 19/04/2023 2698964415 add button  class name.
Akhila 04/25/2023 2698964415  Added usage and override functionality in transformation group
Ravi 05/15/2023 2698964415  changed name from Manager to Template
Ravi 05/16/2023 2698964415 Fixed page Break issue
Akhila 06/12/2023 2698964415 added role access
Sohel 06/16/2023 2698964415 Changed Fields API in Action and Condition
Ravi 06/23/2023 2698964415 fixed submit issue
Ravi 07/11/2023 2698964415 added type in get api
Sohel 12/12/2023 2701335619 label name change code to name 
Sohel 12/15/2023 2701335619 Processor Group SAVE API Payload Changes
*/
import React, {useEffect, useState, useRef} from 'react';
import {Button} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';
import reusableInputStyles from '../../../../../components/InputStyles';
import DMRSearchPreprocessorsGroup from './DMRSearchPreProcessorsGroup/index';
import DMRAddPreProcessorGroup from './DMRAddPreProcessorGroup';
import {useSelector, useDispatch} from 'react-redux';
import {
  postAddProcessorGroup,
  resetAddPreProcessor,
  fetchAddProcessorGroup,
  fetchFieldsData,
} from '../../../../../redux/reducers/DataManagerRecord';
import {resetBasicInfo} from '../../../../../redux/reducers/DataManagerRecord';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PreprocessorGroupStatic from './PreprocessorGroupStatic/index';
import BreadCrums from '../../../../../util/BreadCrum';
import {setAlertData} from '../../../../../redux/reducers/UnsavedChangesAlertReducer';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

const DMRProcessorGroup = ({
  handleBack,
  setValue,
  exportManagerRecord,
  handleDirty,
  hidden,
  showAlertRef,
  managerRecordGroup = false,
  dmTempRecordAccess,
  editExisting,
  exportRecordGroupAccess,
  importRecordGroupAccess,
}) => {
  const classes = reusableInputStyles();
  const [showSearch, setShowSearch] = useState(false);
  const [processorGroupCode, setProcessorGroupCode] = useState('');
  const [dmProcessorGroupId,setDmProcessorGroupId] =useState(0);
  const dispatch = useDispatch();
  const saveRef = useRef();
  // const showAlert = useRef();
  const {prepProcessorGroupData} = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const {
    addProcessorSuccessMsg,
    addProcessorErrorMsg,
    addProcessorStatus,
    recordCode,
    dataManagerRecordId,
    addProcessorGroupData,
    basicInfoSuccessMsg,
    basicInfoData,
    isBasicInfoLoading,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  useEffect(() => {
    if (basicInfoSuccessMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [basicInfoSuccessMsg]);

  const type = exportManagerRecord ? 'Export' : 'Import';
  const handleSubmit = () => {
    if (recordCode) {
      dispatch(submissionStart());
      const payload = {
        dmProcessorGroupMapId: addProcessorGroupData?.dmProcessorGroupMapId ?
          addProcessorGroupData?.dmProcessorGroupMapId :
          0,
        isDraft: 'N',
        processorGroupCode: processorGroupCode,
        recordCode: recordCode,
        fileType: type,
        lastStep: hidden ? 4 : 3,
        dmRecordId : dataManagerRecordId ? dataManagerRecordId : 0,
        dmProcessorGroupId : dmProcessorGroupId ? dmProcessorGroupId :0,
      };
      dispatch(postAddProcessorGroup(payload));
    }
  };
  useEffect(() => {
    handleDirty(addProcessorGroupData?.processorGroupCode !== processorGroupCode);
  }, [processorGroupCode]);
  useEffect(() => {
    if (addProcessorGroupData?.processorGroupCode && !showSearch) {
      setProcessorGroupCode(
        processorGroupCode ? processorGroupCode : addProcessorGroupData?.processorGroupCode,
      );
      setDmProcessorGroupId(dmProcessorGroupId ? dmProcessorGroupId : addProcessorGroupData?.dmProcessorGroupId )
    }
  }, [addProcessorGroupData, showSearch]);
  useEffect(()=>{
    if(prepProcessorGroupData?.dmProcessorGroupId){
      setDmProcessorGroupId(dmProcessorGroupId ? dmProcessorGroupId : prepProcessorGroupData?.dmProcessorGroupId)
    }
  },[prepProcessorGroupData])
  useEffect(() => {
    if (addProcessorErrorMsg || addProcessorSuccessMsg) {
      setTimeout(() => {
        dispatch(resetAddPreProcessor());
      }, 1500);
    }
  }, [addProcessorErrorMsg, addProcessorSuccessMsg]);
  useEffect(() => {
    if (addProcessorStatus === 200 && addProcessorSuccessMsg) {
      setTimeout(() => {
        if (!saveRef.current) {
          setValue(0);
        }
        dispatch(resetAddPreProcessor());
      }, 1500);
    }
  }, [addProcessorStatus, addProcessorSuccessMsg]);
  useEffect(() => {
    if (dataManagerRecordId) {
      dispatch(fetchAddProcessorGroup(type, dataManagerRecordId));
    }
  }, [dataManagerRecordId]);
  useEffect(() => {
    if (dataManagerRecordId) {
      dispatch(fetchFieldsData(type, dataManagerRecordId, managerRecordGroup));
    }
  }, [dataManagerRecordId]);
  useEffect(() => {
    setProcessorGroupCode('');
    setDmProcessorGroupId(0);
  }, []);
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  return showSearch ? (
    <div className="new-standard-textfields">
      <Button
        variant="text"
        className={'mb-2 search-btn'}
        onClick={() => {
          if (showAlertRef.current) {
            //  showAlertRef.current = true
            dispatch(
              setAlertData({
                showAlert: showAlertRef.current,
                alertCallback: () => {
                  setShowSearch(false);
                },
              }),
            );
          } else {
            setShowSearch(false);
          }
        }}
      >
        <ArrowBack className="mr-2" />
        Go Back
      </Button>
      <div>
        <BreadCrums
          name={exportManagerRecord ? 'Export Template Record Name' : 'Import Manager Record Name'}
          code={basicInfoData?.recordCode}
          description={
            exportManagerRecord ?
              'Export Template Record Description' :
              'Import Manager Record Description'
          }
          descriptionValue={basicInfoData?.recordDescription}
          returnType={'Type'}
          returnTypeValue={basicInfoData?.recordType || ''}
        />
      </div>
      <DMRAddPreProcessorGroup
        setShowSearch={setShowSearch}
        setProcessorGroupCode={setProcessorGroupCode}
        exportManagerRecord={exportManagerRecord}
        handleDirty={handleDirty}
        // showAlert={showAlert}
        showAlertRef={showAlertRef}
        editExisting={editExisting}
        dmTempRecordAccess={dmTempRecordAccess}
        exportRecordGroupAccess={exportRecordGroupAccess}
        importRecordGroupAccess={importRecordGroupAccess}
      />
    </div>
  ) : (
    <>
      <div>
        <BreadCrums
          name={exportManagerRecord ? 'Export Template Record Name' : 'Import Template Record Name'}
          code={basicInfoData?.recordCode}
          description={
            exportManagerRecord ?
              'Export Template Record Description' :
              'Import Template Record Description'
          }
          descriptionValue={basicInfoData?.recordDescription}
          returnType={'Type'}
          returnTypeValue={basicInfoData?.recordType || ''}
        />
      </div>
      <DMRSearchPreprocessorsGroup
        setShowSearch={setShowSearch}
        setProcessorGroupCode={setProcessorGroupCode}
        processorGroupCode={processorGroupCode}
        exportManagerRecord={exportManagerRecord}
        handleDirty={handleDirty}
        dmTempRecordAccess={dmTempRecordAccess}
        editExisting={editExisting}
        setDmProcessorGroupId={setDmProcessorGroupId}
      />
      {processorGroupCode && (
        <>
          <PreprocessorGroupStatic prepProcessorGroupData={prepProcessorGroupData} />
        </>
      )}
      <div className="new-standard-textfields d-flex justify-content-center mt-3 new-standard-textfields">
        <Button
          variant="outlined"
          onClick={() => {
            handleBack();
          }}
          className={`reset-btn mr-1 ${classes.buttonRoot}`}
        >
          Back
        </Button>
        {/* {isDraftRecord === "N" && ( */}
        <Button
          variant="outlined"
          disabled={(editExisting && !dmTempRecordAccess?.edit) || enabledSubmission}
          onClick={() => {
            handleSubmit();
            saveRef.current = true;
          }}
          className={`search-btn ml-1 ${classes.buttonRoot}`}
        >
            Save
        </Button>
        {/* )} */}
        <Button
          variant="outlined"
          disabled={!processorGroupCode || (editExisting && !dmTempRecordAccess?.edit) || enabledSubmission}
          onClick={() => {
            handleSubmit();
            saveRef.current = false;
          }}
          className={`search-btn ml-1 ${classes.buttonRoot}`}
        >
          Finish
        </Button>
        {/* )} */}
      </div>
      {(isBasicInfoLoading || printUsageIsLoading) && <PageLoader />}
      {(addProcessorErrorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={addProcessorErrorMsg || printUsageErrorMsg} />
      )}
      {(addProcessorSuccessMsg || basicInfoSuccessMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar
          successMsg={addProcessorSuccessMsg || basicInfoSuccessMsg || printUsageSuccessMsg}
        />
      )}
    </>
  );
};

export default DMRProcessorGroup;
